import Pusher from 'pusher-js';
import { Injectable } from '@angular/core';
import Bugsnag from '@bugsnag/js';

import { Config } from 'shared/config/env.config';

@Injectable()
export class PusherService {
  pusher: Pusher;

  constructor() {
      this.pusher = new Pusher(Config.PUSHER_KEY, {
        cluster: 'us2'
      });
    this.pusher.connection.bind('disconnected', () => {
      console.log(this.pusher.connection.state);
      if (Config.BUGSNAG_KEY) {
        const errorMessage = 'Pusher connection establishing error';
        Bugsnag.notify(new Error(errorMessage));
      }
    });
  }

  getPusher() {
    return this.pusher;
  }
}
